import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import classes from '../DirectoryBox.module.css';
export const DirectoryBoxRow = ({ code, name, isHighlighted }) => {
    return (_jsxs("div", { className: classes.directoryBoxRow, children: [code, "\u00A0", _jsx("span", { className: clsx(!isHighlighted && classes.directoryItemName), children: name })] }));
};
